import {
    ADD_MEMBER_PROMOTIONS_SUCCESS,
    VALIDATE_MEMBER_PROMOTIONS,
    VALIDATE_MEMBER_PROMOTIONS_ERROR,
    VALIDATE_MEMBER_PROMOTIONS_SUCCESS,
} from "core-web/state/models/Basket/constants";

import { BASKET_PROMOTION_ITEM_DATA } from "theme/config/constants";
import { BasketEvents } from "core-web/libs/Events/constants";
import Cookies from "js-cookie";
import Events from "core-web/libs/Events";
import { acquireMutex } from "core-web/state";
import addMemberPromotionsEndpoint from "core-web/libs/GrebbCommerceAPI/promotions/addMemberPromotionsEndpoint";
import buildCartProductTree from "core-web/utils/buildCartProductTree";
import getBasketInfoFieldByCode from "core-web/state/models/Basket/utils/getBasketInfoFieldByCode.ts";
import store from "core-web/state/store";

export const validateMemberPromotions = (promotionIds) => async (dispatch, getState) => {
    const basketId = getState().basket.basketId;
    const mutexLock = await acquireMutex("basket.getBasket");
    const currentMemberPromotionDiscountAmount = getState().basket.memberPromotionDiscountAmount;

    dispatch({ type: VALIDATE_MEMBER_PROMOTIONS });

    try {
        const response = await addMemberPromotionsEndpoint(basketId, promotionIds);
        const status = await response.status();

        if (status === 404) {
            throw "Promotions were not found";
        }

        if (status !== 200) {
            throw "Could not add promotion";
        }

        const responseBody = await response.body();
        const { basket, payments } = responseBody.data;

        const basketItemsTree = buildCartProductTree(basket.items);
        const basketItemsCount = basketItemsTree.reduce((total, item) => total + (item.quantity || 0), 0);
        Cookies.set("basket_items_amount", basketItemsCount);
        Cookies.set("basket_unique_items_amount", basketItemsTree.length);

        const basketPromotionItemData = JSON.parse(
            getBasketInfoFieldByCode(BASKET_PROMOTION_ITEM_DATA, basket.info)?.value || "{}",
        );
        const activeMemberPromotions = Object.keys(basketPromotionItemData).reduce((promotions, partNo) => {
            const currentProductPromotions = basketPromotionItemData?.[partNo];

            if (!currentProductPromotions?.length) {
                return promotions;
            }

            currentProductPromotions.forEach((appliedPromotion) => {
                const { id, discount_amount: discountAmount } = appliedPromotion;

                if (id === null) {
                    return promotions;
                }

                if (promotions.some((promotion) => promotion.id === id)) {
                    promotions = promotions.map((promotion) => {
                        if (promotion.id === id) {
                            return Object.assign(promotion, {
                                discountAmount: promotion.discountAmount + discountAmount,
                            });
                        }

                        return promotion;
                    });
                } else {
                    promotions.push({ id, discountAmount });
                }
            });

            return promotions;
        }, []);

        const memberPromotionDiscountAmount = activeMemberPromotions.reduce(
            (discount, { discountAmount: promotionDiscountAmount }) => (discount += promotionDiscountAmount || 0),
            0,
        );

        let allPromotionsAreValid =
            promotionIds.length === activeMemberPromotions.length &&
            memberPromotionDiscountAmount === currentMemberPromotionDiscountAmount;

        promotionIds.forEach((promotionId) => {
            if (activeMemberPromotions.every((promotion) => promotion.id !== promotionId)) {
                allPromotionsAreValid = false;
            }
        });

        if (allPromotionsAreValid) {
            mutexLock();
            dispatch({
                type: VALIDATE_MEMBER_PROMOTIONS_SUCCESS,
            });

            return true;
        }

        const basketData = {
            items: basketItemsTree,
            summary: basket.format.summary || [],
            promotions: basket.applied_promotions,
            info: basket.info || [],
        };

        dispatch({
            type: ADD_MEMBER_PROMOTIONS_SUCCESS,
            items: basketData.items,
            summary: basketData.summary,
            promotions: basketData.promotions,
            info: basketData.info,
            activeMemberPromotions,
            memberPromotionDiscountAmount,
            payments,
        });

        // Timeout is set to let customer have time to read since widget will reload
        setTimeout(() => {
            Events.trigger(BasketEvents.UPDATED);
        }, 4000);

        mutexLock();

        return false;
    } catch (e) {
        dispatch({ type: VALIDATE_MEMBER_PROMOTIONS_ERROR });

        mutexLock();

        console.error(e);
        return null;
    }
};

export default (promotionIds) => store.dispatch(validateMemberPromotions(promotionIds));
